
/** 
 * 业务类型，【1:充值，2已支付，3系统增加，4，佣金提现，5一级分润，6普通分润，7服务商分润，8共享大使分佣，9上线补贴/设备分佣/充电收益，10，团队转增，11划转，" +
            "12充电间接分润,13充电代理商收益,14充电平级分润,15渠道销售收益,16代理服务费,17渠道流水收益,18流水服务费,19佣金提现,20服务商提现,21渠道提现】
 * 
*/

export const businessTypeOptions = [
  { label: "充值", value: 1 },
  { label: "已支付", value: 2 },
  { label: "系统增加", value: 3 },
  { label: "佣金提现", value: 4 },
  { label: "一级分润", value: 5 },
  { label: "普通分润", value: 6 },
  { label: "经销商销售分润", value: 7 },
  { label: "共享大使分佣", value: 8 },
  { label: "流水收益", value: 9 },
  { label: "团队转赠", value: 10 },
  { label: "划转", value: 11 },
  { label: "服务收益", value: 12 },
  { label: "经销商流水收益", value: 13 },
  { label: "经销商流水收益2", value: 14 },
  { label: "渠道销售收益", value: 15 },
  { label: "代理服务费", value: 16 },
  { label: "渠道流水收益", value: 17 },
  { label: "流水服务费", value: 18 },
  { label: "充电收益提现", value: 19 },
  { label: "经销商销售提现", value: 20 },
  { label: "渠道提现", value: 21 },
  { label: "销售平级收益", value: 22 },
  { label: "加权销售收益", value: 23 },
  { label: "加权流水收益", value: 24 },
  { label: "一级分润退单", value: 25 },
  { label: "经销商销售退单", value: 26 },
  { label: "渠道销售退单", value: 27 },
  { label: "代理服务退单", value: 28 },
  { label: "加权销售退单", value: 29 },
  { label: "销售平级退单", value: 30 },
  { label: "退款", value: 31 },
  { label: "贡献奖", value: 32 },
  { label: "服务收益 2", value: 33 },
  { label: "服务佣金", value: 34 },
  { label: "服务佣金退单", value: 35 },
];

// 资金类型/金币等,1金额，2积分，3转增金额，4充电收益，5是服务商收益
export const amountTypeOptions = [
  {
    label: "佣金金额",
    value: 1,
  },
  // {
  //   label: "积分",
  //   value: 2,
  // },
  {
    label: "转赠金额",
    value: 3,
  },
  {
    label: "充电收益",
    value: 4,
  },
  {
    label: "经销商销售收益",
    value: 5,
  },
  {
    label: "渠道收益",
    value: 7,
  },
];


